import request from './request'

export function listSubcontractOrder(data) {
  return request.post('/supply/subcontract-orders/list', data)
}
export function getSubcontractOrder(id) {
  return request.get('/supply/subcontract-orders/' + id)
}
export function saveSubcontractOrder(data) {
  return request.post('/supply/subcontract-orders', data)
}
export function updateSubcontractOrder(data) {
  return request.post('/supply/subcontract-orders/update', data)
}
export function deleteSubcontractOrder(ids) {
  return request.post('/supply/subcontract-orders/delete', ids)
}
export function releaseSubcontractOrder(id) {
  return request.post('/supply/subcontract-orders/release', { subcontractId: id })
}
export function receiveSubcontractOrder(data) {
  return request.post('/supply/subcontract-orders/receive', data)
}
export function unreceiveSubcontractOrder(id) {
  return request.post('/supply/subcontract-orders/unreceive', { subcontractId: id })
}
export function reportSubcontractOrder(data) {
  return request.post('/supply/subcontract-orders/report', data)
}
export function closeSubcontractOrder(id) {
  return request.post('/supply/subcontract-orders/close', { subcontractId: id })
}
